<template>
  <WaterDropIcon
    v-if="isDisabled && !isSecondary"
    :isLeakage="isLeakage"
  />
  <button
    v-else
    @click="handleSubmitLeakage"
    @mouseenter="hover = true"
    @mouseleave="hover = false"
    :style="{
      width: width + 'px',
      height: height + 'px',
      backgroundColor: hover && !isSecondary ? (isLeakage ? '#ffeff0' : '#f0f0f0') : '#fafafa',
      border: '1px solid ' + (
        isLeakage
          ? (isSecondary ? '#9a9a9a' : (hover && !isSecondary ? '#b80008' : '#E10009'))
          : (hover && !isSecondary ? '#999999' : '#cccccc')
      ),
      borderRadius: '8px',
      cursor:  isSecondary ? 'no-drop' : 'pointer',
      transition: 'background 0.15s ease-in-out, border 0.15s ease-in-out, color 0.15s ease-in-out',
      color: isSecondary ? (this.isSecondary ? '#9a9a9a' : '#E10009') : '#fff',
    }"
  >
    <div v-if="hover && !isDisabled && isSecondary">
      <WaterDropIcon :isLeakage="true"/>
    </div>
    <div v-else>
      <WaterDropIcon :isLeakage="isLeakage"/>
    </div>
  </button>
</template>

<script>
// import ButtonApp from '../button/ButtonApp.vue'
import WaterDropIcon from '../icons/WaterDropIcon.vue'

export default {
  name: 'ButtonLeakage',
  components: {
    // ButtonApp,
    WaterDropIcon
  },
  props: {
    dataHeaderProps: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      dataHeader: null,
      isLeakage: false,
      isDisabled: false,
      isSecondary: false,
      width: '40px',
      height: '40px',
      hover: false
    }
  },
  methods: {
    handleSubmitLeakage () {
      if (!this.isDisabled) {
        this.isLeakage = !this.isLeakage
        this.$emit('toggle-leakage', {
          projectId: this.dataHeader?.id,
          isLeakage: this.isLeakage
        })
      }
    }
  },
  created () {
    this.dataHeader = this.dataHeaderProps
    this.isLeakage = Boolean(Number(this.dataHeaderProps?.is_leakage))
    this.isDisabled = this.dataHeaderProps?.isDisabled || false
    this.height = this.dataHeaderProps?.height || '40px'
    this.width = this.dataHeaderProps?.width || '40px'
    this.isSecondary = this.dataHeaderProps?.is_secondary || false
  },
  watch: {
    dataHeaderProps (val) {
      this.dataHeader = val
      this.isLeakage = Boolean(Number(val?.is_leakage))
      this.isDisabled = val?.isDisabled || false
      this.height = val?.height || '40px'
      this.width = val?.width || '40px'
      this.isSecondary = val?.is_secondary || false
    }
  }
}
</script>
